import { PortalFinancials } from "@/features/portal/components/financials/portal-financials";

/** `/portal/financials/:tab` — limited-field 433 worksheet tabs. */
export default function FinancialsPage() {
  return <PortalFinancials />;
}
